<!--材料预约列表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="organizationCode"
          v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
          selectType="selectAssemble"
          :selectData="inventOrg"
          :disabled="isDisableOrganization"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiEmployeeExport" ref="download" />
        <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="() => handleOk(false)" />
        <create-modal ref="createModalRef" @refresh="handleOk" />
        <a-button v-hasPermi="['bom:bomEmployeeCc:save']" type="primary" :loading="loading" @click="onCreate">新增</a-button>
        <a-button v-hasPermi="['bom:bomEmployeeCc:remove']" :loading="loading" @click="onDelete">删除</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['bom:bomEmployeeCc:import']" @click="handleImport">导入</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['bom:bomEmployeeCc:export']" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1140 }"
        >
          <!-- 供应类型  -->
          <template slot="sex" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-select v-else v-model="record.sex" placeholder="请选择" class="pub-select">
              <!-- 后端说传中文就好，虽然我觉得很不合理 -->
              <a-select-option value="女">女</a-select-option>
              <a-select-option value="男">男</a-select-option>
            </a-select>
          </template>
          <!-- 编号 -->
          <template slot="number" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.number" placeholder="请输入" :maxLength="64" />
          </template>
          <!-- 系统账号 -->
          <template slot="rmsAccount" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.rmsAccount" placeholder="请输入" :maxLength="40" />
          </template>
          <!-- 手机号 -->
          <template slot="phoneNumber" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.phoneNumber" placeholder="请输入"/>
          </template>
          <!-- 邮箱 -->
          <template slot="email" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.email" placeholder="请输入"/>
          </template>
          <!-- 岗位 -->
          <template slot="positionName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              v-model="record.position"
              :selectData="positionList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
            />
          </template>
          <template slot="workshopDesc" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              v-model="record.workshopCode"
              :selectData="workshopList"
              selectType="selectFilter"
              :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
            />
          </template>
          <span slot="operation" slot-scope="text">
            <a
              v-if="(!isEdit || currentId !== text.record.id)"
              v-hasPermi="['bom:bomEmployeeCc:save']"
              @click="handleEdit(text.record)"
            >编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'

import {
  apiEmployeeList,
  apiEmployeeUpdate,
  apiEmployeeExport,
  apiEmployeeDel
 } from '@/api/mes/productionPrepare/employee'
import { apiBomWorkshopFindList } from '@/api/mes/productionPrepare/attributeMaintenance'
import createModal from './components/create-modal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"

import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'Employee',
  components: { DownloadModal, createModal, ImportExcel },
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  data() {
    return {
      apiEmployeeExport,
      loading: false, // 请求loading
      isEdit: false,
      currentId: '',
      currentEditOrganizationCode: '', // 用于记录当前修改行的所属组织编码，用于避免多次调用所属车间下拉框接口
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiEmployeeList, false),
        pageCurrent: true
      },
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/bom/employee/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'bom/employee/template',
        name: `人员维护导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      workshopList: [], // 车间列表
      positionList: [], // 岗位列表
      // 查询参数
      queryParams: {
        desOrganizationCode: undefined,
        organizationCode: undefined,
        employeeName: undefined,
        employeeCode: undefined,
        number: undefined,
        rmsAccount: undefined
      },
      formList: [
        { label: '组织', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '姓名', decorator: ['employeeName'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '人员编码', decorator: ['employeeCode'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '编号', decorator: ['number'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '系统账号', decorator: ['rmsAccount'], type: 'input', attrs: { placeholder: '请输入' } }],
      // 表格字段
      columns: [
        { title: '人员编码', dataIndex: 'employeeCode', align: 'center', width: 200 },
        {
          title: '编号',
          dataIndex: 'number',
          scopedSlots: {
            customRender: 'number'
          },
          align: 'center',
          width: 140
        },
        { title: '姓名', dataIndex: 'employeeName', align: 'center', width: 140 },
        {
          title: '性别',
          dataIndex: 'sex',
          scopedSlots: {
            customRender: 'sex'
          },
          align: 'center',
          width: 100
        },
        {
          title: '系统账号',
          dataIndex: 'rmsAccount',
          scopedSlots: {
            customRender: 'rmsAccount'
          },
          align: 'center',
          width: 160
        },
        {
          title: '手机号',
          dataIndex: 'phoneNumber',
          scopedSlots: {
            customRender: 'phoneNumber'
          },
          align: 'center',
          width: 160
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          scopedSlots: {
            customRender: 'email'
          },
          align: 'center',
          width: 160
        },
        {
          title: '岗位',
          dataIndex: 'positionName',
          scopedSlots: {
            customRender: 'positionName'
          },
          align: 'center',
          width: 160
        },
        { title: '所属组织', dataIndex: 'organizationName', align: 'center', width: 200 },
        {
          title: '所属车间',
          dataIndex: 'workshopDesc',
          scopedSlots: {
            customRender: 'workshopDesc'
          },
          align: 'center',
          width: 200
        },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('MES_ROLE', { lookupType: 'MES_ROLE', current: 1, pageSize: 999 }, 'positionList')
    this.queryParams.organizationCode = this.organizationCodeOrigin;
    this.queryParams.desOrganizationCode = this.organizationCodeOrigin;
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 行选中
    selectedRowChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      // 如果上一个修改行的所属组织与当前行的所属组织不一样，重新获取所属车间
      if (this.currentEditOrganizationCode !== record.organizationCode) {
        apiBomWorkshopFindList({
          workshopStatus: "Y",
          organizationCode: record.organizationCode
        }).then(res => {
          if (res && res.length > 0) {
              this.workshopList = res
            } else {
              this.workshopList = []
            }
        });
        this.currentEditOrganizationCode = record.organizationCode
      }

      this.isEdit = true
      this.currentId = record.id
    },
    // 保存
    handleSave(record) {
      if (!record?.sex) {
        this.$message.warning('请输入性别')
        return
      }

      const emailRegex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (record.email && !emailRegex.test(record.email)) {
        this.$message.warning('请输入正确的邮箱')
        return
      }

      const phoneNumberRegex = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (record.phoneNumber && !phoneNumberRegex.test(record.phoneNumber)) {
        this.$message.warning('请输入正确的手机号码')
        return
      }

      this.loading = true

      apiEmployeeUpdate(record)
        .then((res) => {
          if (res?.code === 200) {
            this.$message.success('编辑成功')
            this.handleOk(true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false
      this.currentId = ''
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        desOrganizationCode: this.organizationCodeOrigin,
        organizationCode: this.organizationCodeOrigin,
        employeeName: undefined,
        employeeCode: undefined,
        number: undefined,
        rmsAccount: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 新增物料
    onCreate() {
      this.$refs.createModalRef.show()
    },
    // 删除
    onDelete() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: '请确认是否删除勾选单据？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          const codes = self.selectedRows.map(item => item.employeeCode)
          apiEmployeeDel(codes).then(res => {
            if (res?.code === 200) {
              self.$message.success(res?.msg || '操作成功')
              self.handleOk()
            }
          }).finally(() => {
            self.loading = false;
          })
        }
      })
    },
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.pub-select {
  /deep/ .ant-select {
    width: 100%;
  }
}
</style>
